import { Badge, Tooltip } from "@hightouch/htui";

const STATUSES = new Map([
  [
    "draft",
    {
      label: "Draft",
      description: "Publish this template to use it when creating ads.",
    },
  ],
  [
    "ready",
    {
      label: "Published",
      description: "This template is available when creating ads.",
    },
  ],
  [
    "importing",
    { label: "Importing", description: "This template is being imported." },
  ],
  [
    "needs-attention",
    {
      label: "Needs attention",
      description: "Open the import session to continue this template.",
    },
  ],
  [
    "failed",
    {
      label: "Import failed",
      description: "Open the import session to retry this template.",
    },
  ],
]);

export function TemplateFileStatus({ status }: { status: string }) {
  const display = STATUSES.get(status);
  if (!display) {
    return null;
  }
  return (
    <Tooltip message={display.description}>
      <Badge size="sm">{display.label}</Badge>
    </Tooltip>
  );
}
